export enum PaymentMethodEnum {
  BCELONE = "BCELONE",
  CASH = "CASH",
}
